import { styled } from 'libs/ui/styled';

export const HintContainer = styled('span')({
  display: 'inline-flex',
});
